import React from 'react';

const Logo = ({ size = 'md' }) => {
  const sizes = {
    sm: 'h-6 w-6',
    md: 'h-8 w-8',
    lg: 'h-10 w-10'
  };

  return (
    <div className="flex items-center">
      <div className={`relative ${sizes[size]}`}>
        {/* Main circle with gradient */}
        <div className="absolute inset-0 rounded-full bg-gradient-to-br from-blue-500 via-purple-500 to-pink-500"></div>
        
        {/* Inner lens effect */}
        <div className="absolute inset-[15%] rounded-full bg-white dark:bg-gray-900 opacity-30"></div>
        
        {/* Camera lens effect */}
        <div className="absolute inset-[30%] rounded-full border-2 border-white dark:border-gray-200 opacity-70"></div>
        
        {/* Light reflection */}
        <div className="absolute top-[20%] left-[20%] h-[15%] w-[15%] rounded-full bg-white"></div>
      </div>
      <span className="ml-2 font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600 dark:from-blue-400 dark:to-purple-400">
        AI Studio
      </span>
    </div>
  );
};

export default Logo;